var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhotoCamera(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 16C2 18.2105 3.78947 20 6 20H18C20.2105 20 22 18.2105 22 16V8C22 5.78947 20.2105 4 18 4H16.4211L14.7018 2.29825C14.5263 2.10526 14.2807 2 14 2H10C9.7193 2 9.47369 2.10526 9.29825 2.29825L7.57895 4H6C3.78947 4 2 5.78947 2 8V16ZM7 12C7 9.22807 9.22807 7 12 7C14.7719 7 17 9.22807 17 12C17 14.7719 14.7719 17 12 17C9.22807 17 7 14.7719 7 12ZM9 12C9 13.7895 10.2105 15 12 15C13.7895 15 15 13.7895 15 12C15 10.2105 13.7895 9 12 9C10.2105 9 9 10.2105 9 12Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhotoCamera);
export default __webpack_public_path__ + "static/media/photo_camera.a82e21ae.svg";
export { ForwardRef as ReactComponent };